<template>
    <div v-if="opportunity" class="offer-container">
        <div class="info">
            <p class="title">{{ `${opportunity.venue_name} is looking for a vibe that's` }}</p>
            <p class="vibes">{{ opportunity.vibe.split(',').join(', ') }}</p>
            <p class="details">{{ opportunity.opportunity_detail }}</p>
        </div>
        <div class="date-location">
            <p class="date">{{ opportunity.date.split(' ').splice(1).join(' ') }}</p>
            <p class="location">
                {{ opportunity.city_with_state_address.trim() }}
            </p>
        </div>
        <div class="payout">
            <p class="label">Accepting Offers</p>
            <p v-if="opportunity.budget_without_commission !== '0.00'" class="payout-info">
                {{ `Up to $${Math.floor(opportunity.budget_without_commission)}` }}
            </p>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'Offer',
        props: {
            opportunity: {
                type: Object
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../../../sass/_variables.scss';
    .offer-container {
        padding: 16px;
        @include flex-start;
        flex-direction: column;
        justify-content: flex-start;
        gap: 8px;
        background: $black-4;
        width: 100%;
        border-radius: 16px;

        p {
            margin-bottom: 0px;
        }

        .info,
        .date-location,
        .payout {
            @include flex-start;
            flex-direction: column;
            justify-content: flex-start;

            .title {
                color: $white;
                font-variant-numeric: ordinal;
                @include base-font-16;
                font-weight: 600;
                line-height: 20px;
                text-wrap: wrap;
            }
            .vibes {
                color: $white;
                font-variant-numeric: ordinal;
                @include base-font-12;
            }
            .details,
            .label {
                color: $darker-grey;
                font-variant-numeric: ordinal;
                @include base-font-12;
                font-weight: 400;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: pre-line;
            }

            .date,
            .payout-info {
                color: $white;
                font-variant-numeric: ordinal;
                @include base-font-16;
                line-height: 24px;
            }
            .location {
                color: $white;
                font-variant-numeric: ordinal;
                @include base-font-12;
            }
        }
    }
</style>
